<template>
  <v-container bg fill-height grid-list-md text-xs-center>
    <v-layout row wrap align-center>
      <v-flex>
        <v-card v-if="isVisiblePDF">
          <v-card-title class="justify-center font-weight-bold">Por favor, lee el documento y si estás de acuerdo, acéptalo</v-card-title>
          <v-card-text>
            <v-layout row>
              <v-flex lg12 md12 sm12 xs12 align-center>
                <esign-view-pdf
                    :token="$store.getters.esignToken"
                    :end-point="`${endPoint}${'getdocumentbyuuidb64/'}`"
                    :operation-uuid="$store.getters.operationUuid"
                    :document-uuid="$store.getters.documentUuid"
                    :width=500
                    :height=710
                    :status=0
                    response=""
                    :loading=false
                    :snack-bar=false
                    success-msg="El documento ha sido descargado"
                    error-msg="Ha ocurrido un error al descargar el documento"
                ></esign-view-pdf>
              </v-flex>
            </v-layout>
          </v-card-text>
          <v-card-actions class="justify-center">
            <esign-read-document-sign-otp v-if="isVisibleReadDocument"
                :token="$store.getters.esignToken"
                :end-point-read-document="`${endPoint}${'documentread/'}`"
                :end-point-sign-otp="`${endPoint}${'createotp/'}`"
                :operation-uuid="$store.getters.operationUuid"
                :document-uuid="$store.getters.documentUuid"
                :domain-uuid="$store.getters.domainUuid"
                :cell-phone="$store.getters.cellphone"
                button-text="Documento Leído y Aceptado"
                :status=0
                response=""
                :loading=false
                :snack-bar=false
                success-msg="Has leido y aprobado el contenidoo del documento. Se  te ha enviado un código OTP. Usalo para completar la firma del documento. "
                error-msg-read-document="Error al registrar la aprobación del documento"
                error-msg-sign-otp="Error al enviar la OTP"
            ></esign-read-document-sign-otp>
          </v-card-actions>
        </v-card>
        <v-card v-if="isVisibleOTP">
          <v-card-title class="justify-center font-weight-bold">Para firmar el documento, escribe el código OTP que has recibdido en tu móvil</v-card-title>
          <v-card-text>            
            <esign-insert-otp-code v-if="isVisibleOTP"
              label-text="Escribe aquí  el código  OTP recibido"
            ></esign-insert-otp-code>
          </v-card-text>
          <v-card-actions class="justify-center">
            <esign-signature-otp-verify
              :token="$store.getters.esignToken"
              :end-point="`${endPoint}${'verifyotpforbot/'}`"
              :domain-uuid="$store.getters.domainUuid"
              button-text="Firmar"
              :operation-uuid="$store.getters.operationUuid"
              otp-type="FIRMA"
              :status=0
              response=""
              :loading=false
              :snack-bar=false
              success-msg="El código OTP ha sido verificado"
              error-msg="Ha ocurrido un error al verificar el código OTP"
          ></esign-signature-otp-verify> 
          </v-card-actions>
        </v-card>
      </v-flex>
    </v-layout>
    <v-snackbar
      v-model="isSnackBarVisible"
      :top=true
      :color="snackBarColor"
      :right=true
      :timeout=4000>
      {{ snackBarText }}
    </v-snackbar>
  </v-container>
</template>

<script>
// @ is an alias to /src
import EsignViewPdf from "@/components/signature/ViewPDF";
import EsignReadDocumentSignOtp from "@/components/signature/ReadDocumentSignOTP";
import EsignInsertOtpCode from "@/components/signature/OTPInsertCode";
import EsignSignatureOtpVerify from "@/components/signature/OTPVerify";
export default {
  name: "simpleSignature",
  components: {
    EsignViewPdf,
    EsignReadDocumentSignOtp,
    EsignInsertOtpCode,
    EsignSignatureOtpVerify
  },
  beforeCreate() {
    window.scrollTo(0, 0);
  },
  data() {
    return {
      endPoint: process.env.VUE_APP_BASEURL,
      isVisiblePDF: true,
      isVisibleReadDocument: false,
      isVisibleMarkAsRead: false,
      isVisibleOTP: false,
      isVisibleSignedPDF: false,
      isVisibleActa: false,
      snackBarColor: "",
      snackBarText: "",
      isSnackBarVisible: false
    };
  },
  mounted() {
    // Google Analytics
    // this.$ga.page(this.$router);
    this.EventBus.$on("successViewPDF", () => {
      this.isVisibleReadDocument = true;
    });
    this.EventBus.$on("errorViewPDF", () => {
      this.snackBarColor = "error";
      this.snackBarText =
        "Ha ocurrido un error al visualizar el documento. Por favor, refresca la página";
      this.isSnackBarVisible = true;
    });
    this.EventBus.$on("notifyViewPDF", () => {});

    this.EventBus.$on("successReadDocumentSignOTP", () => {
      this.isVisiblePDF = false;
      this.isVisibleReadDocument = false;
      this.isVisibleOTP = true;
    });
    this.EventBus.$on("errorReadDocumentSignOTP", () => {
      this.snackBarColor = "error";
      this.snackBarText =
        "Ha ocurrido un error al aceptar el documento. Por favor prueba otra vez";
      this.isSnackBarVisible = true;
    });
    this.EventBus.$on("notifyReadDocumentSignOTP", () => {});

    this.EventBus.$on("successSignatureOtpVerify", () => {
      this.isVisibleOTP = false;
      this.$router.push({ name: "resumeSignature" });
    });
    this.EventBus.$on("errorSignatureOtpVerify", () => {
      this.snackBarColor = "error";
      this.snackBarText =
        "Ha ocurrido un errro al firmar el documento.  Por favor prueba otra vez";
      this.isSnackBarVisible = true;
    });
    this.EventBus.$on("notifySignatureOtpVerify", () => {});
  }
};
</script>

<style scoped>
</style>
